import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';

import { BaseService } from './base.service';
import { User } from '../models/user.model';
import { UserPermission } from '../models/user-permission.model';

@Injectable()
export class UserService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getUsers(): Promise<User[]> {
    return this.get('admin/user');
  }

  async updateUser(userId: number, user: User, permissions?: UserPermission) {
    return this.post('admin/user/' + userId, user);
  }

  async deleteUser(userId: number) {
    return this.delete('admin/user/' + userId);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts